import { render, staticRenderFns } from "./DependencyEditor.vue?vue&type=template&id=f6b11a8e&scoped=true"
import script from "./DependencyEditor.vue?vue&type=script&lang=js"
export * from "./DependencyEditor.vue?vue&type=script&lang=js"
import style0 from "./DependencyEditor.vue?vue&type=style&index=0&id=f6b11a8e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b11a8e",
  null
  
)

export default component.exports